import Api from "./Api";
import apiPath from "@/constants/api.js";

export default {
  ebarimtSend() {
    const response = Api().post(apiPath.ebarimtSend);
    return response;
  },

  failedDataCount() {
    const response = Api().post(apiPath.failedDataCount);
    return response;
  },

  executeFailedData() {
    const response = Api().post(apiPath.executeFailedData);
    return response;
  }
};
